import React, { Fragment, FunctionComponent } from "react";

import { Layout, VerticalDivider } from "@multiweb/reactComponents";
import { bemClassNames, createQA } from "@multiweb/reactUtils";
import { QAProps } from "@multiweb/types/react";
import { Column } from "../Column";

export type AggregationRowComponentProps = {
    /** Klíč agregačního řádku. */
    aggregationRowKey: string;
    /** Pole klíčů sloupců se zmraženým horizontálním scrollováním. */
    frozenColumns: readonly string[];
    /** Pole klíčů sloupců, které nemají zmražené horizontální scrollování. */
    nonFrozenColumns: readonly string[];
} & QAProps;

const classNames = bemClassNames("aggregation-row-component");

/**
 * Vykresluje jednotlivé sloupce agregačního řádku. Nejprve vykreslí uzamčené sloupce, pak ostatní sloupce.
 */
export const AggregationRowComponent: FunctionComponent<AggregationRowComponentProps> = ({
    aggregationRowKey,
    frozenColumns,
    nonFrozenColumns,
    qa,
}) => (
    <div
        className={classNames()}
        {...createQA(qa)}
    >
        <Layout>
            <div className={classNames("background")}>
                <div className={classNames("frozen-part")} >
                    {renderColumns(frozenColumns, aggregationRowKey)}
                    <VerticalDivider />
                </div>
                {renderColumns(nonFrozenColumns, aggregationRowKey)}
            </div>
        </Layout>
    </div>
);

/**
 * Pomocná funkce pro vykreslení sloupců.
 * @param columns Pole klíčů sloupců.
 * @param aggregationRowKey Klíč agregačního řádku.
 */
const renderColumns = (columns: readonly string[], aggregationRowKey: string) => columns.map((columnKey, index) => (
    <Fragment key={columnKey}>
        {index !== 0 && <VerticalDivider />}
        <Column {...{ columnKey, aggregationRowKey }} />
    </Fragment>
));
